import Image from 'next/image';
import dynamic from 'next/dynamic';

import knowYourValue from '../../../../public/images/know-your-value.webp';
import knowYourValueSm from '../../../../public/images/know-your-value-sm.webp';
import knowYourValueMd from '../../../../public/images/know-your-value-md.webp';
import useLayoutSize from '../../../hooks/useLayoutSize';
import {
  Container,
  InlineIcon,
  Row,
  Rows,
  Title,
  ValuePoint,
  ValuePointTitle,
  ValuePointInfo
} from './KeyValue.styles';

const Profile = dynamic(() =>
  import('@carvana/helios-icons/Profile').then(module => module.Profile)
);
const LineGraph = dynamic(() =>
  import('@carvana/helios-icons/LineGraph').then(module => module.LineGraph)
);
const Speed = dynamic(() => import('@carvana/helios-icons/Speed').then(module => module.Speed));

const KeyValues = () => {
  const { isSm, isMd } = useLayoutSize();
  let image;

  if (isMd) {
    image = knowYourValueMd;
  } else if (isSm) {
    image = knowYourValueSm;
  } else {
    image = knowYourValue;
  }

  return (
    <Container>
      <Image src={image} alt="Know Your Value" style={{ width: '100%', height: 'auto' }} priority />
      <Title>Always know your vehicle's value</Title>
      <Rows>
        <Row>
          <InlineIcon>
            <Speed />
          </InlineIcon>
          <ValuePoint>
            <ValuePointTitle>Real insights, delivered</ValuePointTitle>
            <ValuePointInfo>
              Get a personalized value monthly to stay informed on how your value changes. 100% free
              - no purchase or sale necessary.
            </ValuePointInfo>
          </ValuePoint>
        </Row>
        <Row>
          <InlineIcon>
            <Profile />
          </InlineIcon>
          <ValuePoint>
            <ValuePointTitle>You're in control</ValuePointTitle>
            <ValuePointInfo>
              Access key information about your vehicle’s value, market trends and competitive data,
              empowering you to make informed decisions.
            </ValuePointInfo>
          </ValuePoint>
        </Row>
        <Row>
          <InlineIcon>
            <LineGraph />
          </InlineIcon>
          <ValuePoint>
            <ValuePointTitle>Powered by data</ValuePointTitle>
            <ValuePointInfo>
              Carvana’s proprietary techno wizardry scans millions of automotive transactions and
              evolving market conditions to get you a real value.
            </ValuePointInfo>
          </ValuePoint>
        </Row>
      </Rows>
    </Container>
  );
};

export default KeyValues;
